import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import PriceTicker from '../components/PriceTicker/PriceTicker';
import Services from '../components/Services/Services';
import Markets from '../components/Markets/Markets';
import DataPower from '../components/DataPower/DataPower';
import NewsInsights from '../components/NewsInsights/NewsInsights';
import DataStats from '../components/DataStats/DataStats';
import Advantage from '../components/Advantage/Advantage';
import Forum from '../components/Forum/Forum';
import Multimedia from '../components/Multimedia/Multimedia';
import ConsultingCTA from '../components/ConsultingCTA/ConsultingCTA';
import DeliveryMode from '../components/DeliveryMode/DeliveryMode';
import Awards from '../components/Awards/Awards'; 
import FooterCTA from '../components/FooterCTA/FooterCTA';
import Footer from '../components/Footer/Footer';

const HomePage = () => {
  return (
    <>
    <div>
      <Header />
      <Hero />
      <PriceTicker />
      <Services />
      <Markets />
      <DataPower />
      <NewsInsights />
      <DataStats />
      <Advantage />
      <Forum />
      <Multimedia />
      <ConsultingCTA />
      <DeliveryMode />
      <Awards />
      <FooterCTA />
      {/* You can add more sections/components here */}
    </div>
    <Footer />
    </>
  );
};

export default HomePage;